import React from "react"

import { LabeledSwitch } from "../LabeledSwitch"
import { SwitchProps } from "@mui/material/Switch/Switch"
import { styled } from "@mui/material/styles"

interface IProps extends SwitchProps {
  checkedText?: string,
  uncheckedText?: string,
  width?: string
}

const widthDefault = "60px"

const TheSwitch = ({
                     width = widthDefault,
                     ...props
                   }: IProps) =>

  <LabeledSwitch
    {...props}
    checkedText={" "}
    uncheckedText={" "}
    width={width}
    disableRipple
  />


export const Switch = styled(TheSwitch)(({
                                                  width = widthDefault,
                                                }) => ({
    width,

    "& span.MuiButtonBase-root.Mui-disabled": {
      backgroundColor: "#F2F2F2",
    },

    "& span.MuiButtonBase-root.Mui-disabled + span.MuiSwitch-track": {
      backgroundColor: "#CCC !important",
    },

    "& [class*=Mui-checked] + .MuiSwitch-track": {
      backgroundColor: "#008859 !important",
    },

    "& .MuiSwitch-track": {
      backgroundColor: "#999 !important",
    },
  })
)

